export type BlogTopic = {
  id: string;
  label: string;
  /** Regex som matchar titel, utdrag, fokus-nyckelord och keywords */
  re: RegExp;
  /** Rubrik på ämnessidan */
  heading: string;
  /** Intro-text på ämnessidan (unik, SEO-bärande) */
  intro: string;
  /** Meta description för ämnessidan */
  description: string;
};

export const BLOG_TOPICS: BlogTopic[] = [
  {
    id: "husbil",
    label: "Husbil",
    re: /husbil/i,
    heading: "Allt om husbil",
    intro:
      "Guider om husbil – från vilket körkort som krävs till hur du väljer planlösning, chassi och utrustning. Skrivet av oss som säljer och servar husbilar i Kalix varje dag.",
    description:
      "Husbilsguider från AK Husbil & Fritid i Kalix: körkort, planlösningar, chassi, utrustning och köptips. Läs innan du köper husbil.",
  },
  {
    id: "husvagn",
    label: "Husvagn",
    re: /husvagn/i,
    heading: "Allt om husvagn",
    intro:
      "Husvagnsguider om vikter och kopplingsvikt, dragbil, vinterboende och vad du ska kontrollera på en begagnad vagn innan affären.",
    description:
      "Husvagnsguider: vikter, dragbil, vinterboende och besiktning av begagnad husvagn. Råd från handlare i Norrbotten.",
  },
  {
    id: "vinter",
    label: "Vinter & kyla",
    re: /vinter|kyla|frost|snö|förvaring|isolering/i,
    heading: "Vinter, kyla & förvaring",
    intro:
      "Vi står i Kalix – här är vinterkunskapen verklig erfarenhet, inte teori. Läs om vinterförvaring, frostsäkring, isolering och att faktiskt bo i husbilen när det är minus 25.",
    description:
      "Vinterguider för husbil och husvagn: vinterförvaring, frostsäkring, isolering och vinterboende. Erfarenhet från Norrbotten.",
  },
  {
    id: "ekonomi",
    label: "Pris & ekonomi",
    re: /pris|kostnad|budget|finansier|värde|avskriv|försäkring|skatt/i,
    heading: "Pris, ekonomi & finansiering",
    intro:
      "Vad kostar en husbil egentligen – per år, per mil och över tid? Här samlar vi kalkyler, avskrivningskurvor, försäkring, skatt och finansieringsupplägg.",
    description:
      "Ekonomiguider för husbil: driftkostnad, avskrivning, försäkring, skatt och finansiering. Räkna innan du köper.",
  },
  {
    id: "teknik",
    label: "Teknik & el",
    re: /el\b|solcell|batteri|gasol|värme|vatten|panel|teknik/i,
    heading: "Teknik, el & system",
    intro:
      "Solceller, litiumbatterier, gasol, värmesystem och vattensystem – förklarat så att du förstår vad du köper och vad som faktiskt går att bygga ut i efterhand.",
    description:
      "Teknikguider för husbil: solceller, batteri, gasol, värme och vattensystem. Förklarat av verkstaden i Kalix.",
  },
  {
    id: "resa",
    label: "Resmål & ställplatser",
    re: /ställplats|camping|resa|resmål|rutt|norrbotten|lapp/i,
    heading: "Resmål & ställplatser",
    intro:
      "Rutter, ställplatser och resmål med tyngdpunkt på Norrbotten, Lappland och Nordkalotten – platser vi själva kör till.",
    description:
      "Ställplatser och resmål för husbil i Norrbotten och Lappland. Rutter och tips från AK Husbil & Fritid.",
  },
  {
    id: "service",
    label: "Service & underhåll",
    re: /service|underhåll|fukt|däck|reservdel|besiktning|renover/i,
    heading: "Service & underhåll",
    intro:
      "Fukttest, gasoltest, däck, besiktning och reservdelar. Det här är vardagen i vår verkstad – och det som avgör om fordonet håller i tio år till.",
    description:
      "Service och underhåll av husbil och husvagn: fukttest, gasoltest, däck, besiktning och reservdelar.",
  },
  {
    id: "kopguide",
    label: "Köpguide",
    re: /köp|guide|checklista|välja|jämför|begagnad/i,
    heading: "Köpguider & checklistor",
    intro:
      "Checklistor och jämförelser för dig som är på väg att köpa. Vad du ska titta på, vad du ska fråga om och vad som är värt att betala extra för.",
    description:
      "Köpguider för husbil och husvagn: checklistor, jämförelser och vad du ska kontrollera på ett begagnat fordon.",
  },
];

export const BLOG_TOPIC_IDS = BLOG_TOPICS.map((t) => t.id);

export function findBlogTopic(id: string): BlogTopic | undefined {
  return BLOG_TOPICS.find((t) => t.id === id);
}

export function topicHaystack(p: {
  title?: string | null;
  excerpt?: string | null;
  focus_keyword?: string | null;
  keywords?: string[] | null;
}) {
  return [p.title, p.excerpt, p.focus_keyword, ...(p.keywords ?? [])].filter(Boolean).join(" ");
}
